module.exports = __webpack_public_path__ + "img/sir.624c473f.png";